"use client";

import { createRestDataProviderClient } from "@providers/data-provider/rest-data-provider.client";
import { transformQueryParamsWithoutLocale } from "@shared/utils";
import { useQuery } from "@tanstack/react-query";
import { WlkpCompany } from "../model";
import { useClientRest } from "@shared/hooks";

export function useWlkpCompanies({ keyword }: { keyword: string }) {
  const { request } = useClientRest();

  const query = useQuery({
    queryKey: ["wlkp-companies", keyword],
    queryFn: () =>
      request({
        url: transformQueryParamsWithoutLocale("/karirhub/onboarding/v2/companies/search", {
          keyword,
        }),
        method: "GET",
      }),
    enabled: keyword.length > 0,
  });

  const companies: WlkpCompany[] = query.data?.data || [];

  return {
    isLoading: query.isLoading,
    companies,
    refetch: query.refetch,
  };
}
